import { Symbol, SymbolType } from '../types/game.types';

export const SYMBOLS: Record<SymbolType, Symbol> = {
    [SymbolType.TREASURE_CHEST]: {
        id: SymbolType.TREASURE_CHEST,
        name: 'Treasure Chest',
        image: 'treasure_chest.png',
        isWild: false,
        isScatter: false,
        tier: 'high'
    },
    [SymbolType.NEON_DIAMOND]: {
        id: SymbolType.NEON_DIAMOND,
        name: 'Neon Diamond',
        image: 'neon_diamond.png',
        isWild: false,
        isScatter: false,
        tier: 'high'
    },
    [SymbolType.SHOWGIRL_HAT]: {
        id: SymbolType.SHOWGIRL_HAT,
        name: 'Showgirl Hat',
        image: 'showgirl_hat.png',
        isWild: false,
        isScatter: false,
        tier: 'high'
    },
    [SymbolType.SPORTS_CAR]: {
        id: SymbolType.SPORTS_CAR,
        name: 'Sports Car',
        image: 'sports_car.png',
        isWild: false,
        isScatter: false,
        tier: 'high'
    },
    [SymbolType.DICE]: {
        id: SymbolType.DICE,
        name: 'Dice',
        image: 'dice.png',
        isWild: false,
        isScatter: false,
        tier: 'mid'
    },
    [SymbolType.MARTINI]: {
        id: SymbolType.MARTINI,
        name: 'Martini',
        image: 'martini.png',
        isWild: false,
        isScatter: false,
        tier: 'mid'
    },
    [SymbolType.COINS]: {
        id: SymbolType.COINS,
        name: 'Gold Coins',
        image: 'coins.png',
        isWild: false,
        isScatter: false,
        tier: 'mid'
    },
    [SymbolType.HORSESHOE]: {
        id: SymbolType.HORSESHOE,
        name: 'Lucky Horseshoe',
        image: 'horseshoe.png',
        isWild: false,
        isScatter: false,
        tier: 'mid'
    },
    [SymbolType.ACE]: {
        id: SymbolType.ACE,
        name: 'Ace',
        image: 'ace.png',
        isWild: false,
        isScatter: false,
        tier: 'low'
    },
    [SymbolType.KING]: {
        id: SymbolType.KING,
        name: 'King',
        image: 'king.png',
        isWild: false,
        isScatter: false,
        tier: 'low'
    },
    [SymbolType.QUEEN]: {
        id: SymbolType.QUEEN,
        name: 'Queen',
        image: 'queen.png',
        isWild: false,
        isScatter: false,
        tier: 'low'
    },
    [SymbolType.JACK]: {
        id: SymbolType.JACK,
        name: 'Jack',
        image: 'jack.png',
        isWild: false,
        isScatter: false,
        tier: 'low'
    },
    [SymbolType.TEN]: {
        id: SymbolType.TEN,
        name: 'Ten',
        image: 'ten.png',
        isWild: false,
        isScatter: false,
        tier: 'low'
    },
    [SymbolType.WILD]: {
        id: SymbolType.WILD,
        name: 'Wild Starburst',
        image: 'wild.png',
        isWild: true,
        isScatter: false,
        tier: 'special'
    },
    [SymbolType.SCATTER]: {
        id: SymbolType.SCATTER,
        name: 'Boombox Scatter',
        image: 'scatter.png',
        isWild: false,
        isScatter: true,
        tier: 'special'
    },
    [SymbolType.MINI_GAME]: {
        id: SymbolType.MINI_GAME,
        name: 'Mini Game Trigger',
        image: 'mini_game.png',
        isWild: false,
        isScatter: false,
        tier: 'special'
    }
};